import React, { Suspense } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { Spinner } from '../../components/spinner';
import '../../styles/layouts/_layout--feedback.scss';
import { FeedbackDocumentProvider } from '../../contexts/feedback-document';
import { DisplayLanguageFeedbackProvider } from '../../contexts/display-languages-feedback';

/**
 * The layout for private pages.
 * @returns
 */
const FeedbackLayout = () => {
  const { feedbackCode } = useParams();

  document.title = 'Catalyst Portal - Feedback';

  return (
    <Suspense fallback={<Spinner />}>
      <FeedbackDocumentProvider feedbackCode={feedbackCode!}>
        <DisplayLanguageFeedbackProvider>
          <div className={'layout--feedback'}>
            <div className={'app-main'}>
              <Outlet />
            </div>
          </div>
        </DisplayLanguageFeedbackProvider>
      </FeedbackDocumentProvider>
    </Suspense>
  );
};

export default FeedbackLayout;
